export default function DeleteIcon({ color, size }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      style={{ transform: `scale(${size || "1"})` }}
    >
      <g clip-path="url(#clip0_1272_2484)">
        <path
          d="M5.00008 15.8333C5.00008 16.75 5.75008 17.5 6.66675 17.5H13.3334C14.2501 17.5 15.0001 16.75 15.0001 15.8333V7.5C15.0001 6.58333 14.2501 5.83333 13.3334 5.83333H6.66675C5.75008 5.83333 5.00008 6.58333 5.00008 7.5V15.8333ZM7.64175 9.30833C7.96675 8.98333 8.49175 8.98333 8.81675 9.30833L10.0001 10.4917L11.1834 9.30833C11.5084 8.98333 12.0334 8.98333 12.3584 9.30833C12.6834 9.63333 12.6834 10.1583 12.3584 10.4833L11.1751 11.6667L12.3584 12.85C12.6834 13.175 12.6834 13.7 12.3584 14.025C12.0334 14.35 11.5084 14.35 11.1834 14.025L10.0001 12.8417L8.81675 14.025C8.49175 14.35 7.96675 14.35 7.64175 14.025C7.31675 13.7 7.31675 13.175 7.64175 12.85L8.82508 11.6667L7.64175 10.4833C7.31675 10.1667 7.31675 9.63333 7.64175 9.30833ZM12.9167 3.33333L12.3251 2.74167C12.1751 2.59167 11.9584 2.5 11.7417 2.5H8.25841C8.04175 2.5 7.82508 2.59167 7.67508 2.74167L7.08341 3.33333H5.00008C4.54175 3.33333 4.16675 3.70833 4.16675 4.16667C4.16675 4.625 4.54175 5 5.00008 5H15.0001C15.4584 5 15.8334 4.625 15.8334 4.16667C15.8334 3.70833 15.4584 3.33333 15.0001 3.33333H12.9167Z"
          fill={color || "#E24B4B"}
        />
      </g>
      <defs>
        <clipPath id="clip0_1272_2484">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
